define([
    'backbone',
    'basecollection'
], (Backbone, BaseCollection) => BaseCollection.extend({
    url: '/me/role/permissions',
    model: Backbone.Model,

    includes (permission) {
        const permissions = _.wrapArray(permission);
        const userPermissions = this.map((p) => p.id);
        return _.intersection(permissions, userPermissions).length === permissions.length;
    }
}));
